export default function (state, payload) {
  const selfRecording = {
    ...state.selfRecording,
    ...payload,
  };

  state.selfRecording = selfRecording;
}
